<template>
  <el-card shadow="never" :body-style="formStyle" v-loading="loading">
    <el-alert
    title="Warning"
    type="warning">
      {{mandateText}}
    </el-alert>
    <el-form
      label-position="left"
      ref="bank-form"
      :model="bankLogin"
      size="small"
    >
      <el-form-item
        label="Ownership Type"
        prop="ownershipType"
        :rules="[
          { required: true, message: 'Please select Ownership type for the bank' },
          { type: 'string', message: 'Please select Ownership type for the bank',
            trigger: ['blur', 'change'] }
        ]"
      >
        <el-select v-model="bankLogin.ownershipType">
          <el-option value="business" label="Business"></el-option>
          <el-option value="personal" label="Personal"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="Account Type"
        prop="accountType"
        :rules="[
          { required: true, message: 'Please select Account type for the bank' },
          { type: 'string', message: 'Please select Account type for the bank',
            trigger: ['blur', 'change'] }
        ]"
      >
        <el-select v-model="bankLogin.accountType">
          <el-option value="savings" label="Savings"></el-option>
          <el-option value="checking" label="Checking"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="Account Number"
        prop="accountNumber"
        :rules="[
          { required: true, message: 'Please input account number for the bank' },
          { type: 'string', message: 'Please input account type for the bank',
            trigger: ['blur', 'change'] }
        ]"
      >
        <el-input v-model="bankLogin.accountNumber"> </el-input>
      </el-form-item>
      <el-form-item
        label="Routing Number"
        prop="routingNumber"
        :rules="[
          { required: true, message: 'Please input Routing Number for the bank' },
          { type: 'string', message: 'Please input Routing Number for the bank', trigger: ['blur', 'change'] }
        ]"
      >
        <el-input v-model="bankLogin.routingNumber"> </el-input>
      </el-form-item>
      <el-form-item
        v-if="bankLogin.ownershipType === 'business'"
        label="Business Name"
        prop="businessName"
        :rules="bankLogin.ownershipType === 'business' ? [
          { required: true, message: 'Please input Business Name' },
          { type: 'string', message: 'Please input Business Name', trigger: ['blur', 'change'] }
        ] : []"
      >
        <el-input v-model="bankLogin.businessName"> </el-input>
      </el-form-item>
      <el-form-item
        v-if="bankLogin.ownershipType === 'personal'"
        label="First Name"
        prop="firstName"
        :rules="bankLogin.ownershipType === 'personal' ? [
          { required: true, message: 'Please input First Name' },
          { type: 'string', message: 'Please input First Name', trigger: ['blur', 'change'] }
        ] : []"
      >
        <el-input v-model="bankLogin.firstName"> </el-input>
      </el-form-item>
      <el-form-item
        v-if="bankLogin.ownershipType === 'personal'"
        label="Last Name"
        prop="lastName"
        :rules="bankLogin.ownershipType === 'personal' ? [
          { required: true, message: 'Please input Last Name' },
          { type: 'string', message: 'Please input Last Name', trigger: ['blur', 'change'] }
        ] : []"
      >
        <el-input v-model="bankLogin.lastName"> </el-input>
      </el-form-item>
      <el-form-item
        label="Billing Address"
        prop="billingAddress.streetAddress"
        :rules="[
          { required: true, message: 'Please input Address' },
          { type: 'string', message: 'Please input Address', trigger: ['blur', 'change'] }
       ]"
      >
        <el-input v-model="bankLogin.billingAddress.streetAddress" type="textarea"></el-input>
      </el-form-item>
      <el-form-item
        label="Extended Billing Address"
        prop="billingAddress.extendedAddress"
      >
        <el-input v-model="bankLogin.billingAddress.extendedAddress" type="textarea"></el-input>
      </el-form-item>
      <el-form-item
        label="City"
        prop="billingAddress.locality"
        :rules="[
          { required: true, message: 'Please input city' },
          { type: 'string', message: 'Please input city', trigger: ['blur', 'change'] }
        ]"
      >
        <el-input v-model="bankLogin.billingAddress.locality"></el-input>
      </el-form-item>
      <el-form-item
        label="State"
        prop="billingAddress.region"
        :rules="[
          { required: true, message: 'Please select state' },
          { type: 'string', message: 'Please select state', trigger: ['blur', 'change'] }
        ]"
      >
        <State country="us" @change="(state) => bankLogin.billingAddress.region = state" :given-state="bankLogin.billingAddress.region"/>
      </el-form-item>
      <el-form-item label="Postal Code">
        <el-input v-model="bankLogin.billingAddress.postalCode"></el-input>
      </el-form-item>

      <el-form-item>
        <h3>Verification Method</h3>
        <el-radio-group v-model="verificationMethod">
         <el-radio label="Network Check"/>
         <el-radio label="Micro Transfer"/>
      </el-radio-group>
      </el-form-item>

      <el-button @click="startBankLogin">Save</el-button>
    </el-form>
  </el-card>
</template>

<script>
import axios from 'axios';
import { PG_API_BASE } from '../env';
import State from './Sate';

export default {
  name: 'USBankForm',
  components: { State },
  props: {
    customerId: { type: String, required: true },
    customer: { type: Object, default: () => {} },
  },
  data() {
    return {
      formStyle: {
        // eslint-disable-next-line global-require
        // backgroundImage: `url(${require('../assets/images.jpeg')})`,
        // color: 'white',
      },
      loading: false,
      BankComponent: null,
      verificationMethod: 'Network Check',
      mandateText:
        'By clicking Add Bank, I authorize Braintree, a service of PayPal, on behalf of Readyspaces (i) to verify my bank account information using bank information and consumer reports and (ii) to debit my bank account.',
      bankLogin: {
        // displayName: 'Readyspaces',
        routingNumber: null,
        firstName: this.customer.firstName,
        lastName: this.customer.lastName,
        businessName: this.customer.company,
        ownershipType: 'business',
        accountNumber: null,
        accountType: 'savings',
        billingAddress: {
          streetAddress: this.customer.country === 'us' ? this.customer.address : '',
          extendedAddress: this.customer.address2,
          locality: this.customer.country === 'us' ? this.customer.city : '',
          region: this.customer.country === 'us' ? this.customer.state : '',
          postalCode: this.customer.country === 'us' ? this.customer.zip : null,
        },
      },
    };
  },
  async mounted() {
    // eslint-disable-next-line global-require
    const client = require('braintree-web/client');
    // eslint-disable-next-line global-require
    const usBankAccount = require('braintree-web/us-bank-account');
    const response = await axios.get(`${PG_API_BASE}/client/token`, {
      headers: {
        Authorization: `Bearer ${this.$keycloak.token}`,
      },
    });
    const clientInstance = await client.create({
      authorization: response.data.token.clientToken,
    });

    const BankComponent = await usBankAccount.create({
      client: clientInstance,
    });
    this.BankComponent = BankComponent;
  },
  methods: {
    async startBankLogin(ev) {
      ev.preventDefault();
      this.$refs['bank-form'].validate(async (valid) => {
        if (valid) {
          try {
            this.loading = true;
            const body = { ...this.bankLogin };

            if (body.ownershipType === 'business') {
              delete body.firstName;
              delete body.lastName;
            } else {
              delete body.businessName;
            }
            const response = await this.BankComponent.tokenize({
              bankDetails: body,
              mandateText: this.mandateText,
            });

            const paymentResponse = await axios.post(
              `${PG_API_BASE}/customer/create/payment`,
              {
                customerId: this.customerId,
                paymentMethodNonce: response.nonce,
                options: {
                  usBankAccountVerificationMethod: this.verificationMethod === 'Network Check' ? 'network_check' : 'micro_transfers',
                  failOnDuplicatePaymentMethod: true,
                },
              },
              {
                headers: {
                  Authorization: `Bearer ${this.$keycloak.token}`,
                },
              },
            );

            if (!paymentResponse.data.result.success) {
              this.loading = false;
              this.$message.error({
                message: paymentResponse.data.result.message,
              });

              return;
            }

            this.loading = false;
            this.dialog = false;
            this.$emit('bank-added');
          } catch (err) {
            this.loading = false;
            // console.log(err);
            this.dialog = false;
            this.$message.error({
              title: 'Error',
              message: err.details.originalError.details.originalError[0].message,
            });
            this.$emit(
              'error',
              err.details.originalError.details.originalError[0].message,
            );
          }
        }
      });
    },
  },
};
</script>

<style scoped>
.form {
  background-color: #009aca;
}
</style>



// WEBPACK FOOTER //
// src/components/USBankForm.vue